/**
 * Die Gerätekennung im Browser.
 *
 * ⚠️ **Der Anlass, 2026-09-22.** `Device.getId()` gibt im Browser eine leere Zeichenkette
 * zurück. Relay lehnt eine Anmeldung ohne `deviceIdentifier` mit `BAD_REQUEST` ab — im
 * Browser kam damit **keine** Anmeldung zustande, und der ganze Servermodus war am
 * Schreibtisch nicht zu entwickeln.
 *
 * ⚠️ **Sie ist keine Gerätekennung im Sinne der Beglaubigung.** Auf dem iPad kommt sie von
 * iOS; hier ist sie eine Zufallszahl im Profil dieses Browsers. Wer das Profil löscht,
 * bekommt eine neue — und wer es kopiert, nimmt sie mit. Das ist der Grund, warum eine
 * Signatur aus dem Browser `web-crypto` trägt und nicht `secure-enclave`
 * (`platform/signature.ts`).
 */

const SCHLUESSEL = 'fairexa.browser.geraetekennung';

/** Vorsatz, damit man einer solchen Kennung in Protokollen ansieht, woher sie stammt. */
const VORSATZ = 'browser-';

let gemerkt: string | null = null;

/**
 * Eine über Neuladen stabile Kennung dieses Browserprofils.
 *
 * ⚠️ **Der Rückfall auf eine flüchtige Kennung ist Absicht.** Im privaten Fenster und bei
 * abgeschalteten Seitendaten wirft schon der Zugriff auf `localStorage`. Dann gilt sie nur
 * für diese Sitzung — das ist immer noch besser als eine leere, an der die Anmeldung
 * scheitert.
 */
export function browserGeraeteKennung(): string {
  if (gemerkt !== null) return gemerkt;

  try {
    const vorhanden = localStorage.getItem(SCHLUESSEL);
    if (vorhanden) {
      gemerkt = vorhanden;
      return gemerkt;
    }
    const neu = VORSATZ + crypto.randomUUID();
    localStorage.setItem(SCHLUESSEL, neu);
    gemerkt = neu;
    return gemerkt;
  } catch {
    gemerkt = VORSATZ + crypto.randomUUID();
    return gemerkt;
  }
}

/** Nur für Tests: den Merker leeren, damit der nächste Aufruf wieder liest. */
export function vergissBrowserGeraeteKennung(): void {
  gemerkt = null;
}
